import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 11.9167V11.8834M8 10.25C8 8.21004 10 9.15337 10 7.11377C10 4.40657 6 4.40657 6 7.11377", stroke: "#707577", strokeWidth: 0.666667, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8.00065, cy: 8.50004, r: 6.33333, stroke: "#707577", strokeWidth: 0.666667 }));
const ForwardRef = forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
